export default {
  SEARCH_ALLIANZ_ACCOUNT_REPORT_QUERY: Symbol.for('SEARCH_ALLIANZ_ACCOUNT_REPORT_QUERY'),
  ALLIANZ_ACCOUNT_REPORT_REPOSITORY: Symbol.for('ALLIANZ_ACCOUNT_REPORT_REPOSITORY'),
  ALLIANZ_ACCOUNT_REPORT_STATE_MANAGER: Symbol.for('ALLIANZ_ACCOUNT_REPORT_STATE_MANAGER'),
};
